const HeroTV = () => {
  return (
    <div className="border w-full">
      <h1>Hero</h1>
    </div>
  );
};

export default HeroTV;
